import * as api from "../../services/api";
import {useQuery} from "@tanstack/react-query";


/*
 * Query to get all the tourist tax exclusion code for an apartment
 */
export const useLocalTouristTaxExclusionsQuery = () => {
    return useQuery({
        queryKey: ["abitTourustTaxExclusionCodes"],
        queryFn: () => api.Bookings.getLocalTouristTaxExclusions(),
        enabled: true,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
    });
}